import { render, staticRenderFns } from "./DaiLiListPop.vue?vue&type=template&id=c22b5528&"
import script from "./DaiLiListPop.vue?vue&type=script&lang=js&"
export * from "./DaiLiListPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports